import { render, staticRenderFns } from "./TabGroup.vue?vue&type=template&id=3f281140&"
import script from "./TabGroup.vue?vue&type=script&lang=js&"
export * from "./TabGroup.vue?vue&type=script&lang=js&"
import style0 from "./TabGroup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TabGroup.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports